import React from 'react'
import classnames from 'classnames/bind'

import Layout from 'components/shared/Layout'
import LabelTitleText from 'components/shared/LabelTitleText'
import Image from 'components/shared/Image'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const CTABanner = ({ text, image, className }) => {
  return (
    <div className={cx(css.CTABanner, className)}>
      <Layout type="maxWidth">
        <Layout type="wrapper">
          <Layout type="innerWrapper" className={css.wrapper}>
            <div className={css.content}>
              {text && (
                <LabelTitleText
                  titleProps={{ size: 'medium' }}
                  linkProps={{ size: 'small' }}
                  mobileCenter
                  ctaBanner
                  {...text}
                />
              )}
            </div>
            {image && <Image className={css.image} {...image} />}
          </Layout>
        </Layout>
      </Layout>
    </div>
  )
}

export default CTABanner
